export const SEU_NEW_ID = 'new';
export const SEU_NONE_ID = 'none';
